import { publicApi } from '../lib/api'

export type StripePlanPrice = {
  price_id: string
  amount_cents: number | null
  currency: string | null
  interval: 'month' | null
}

export type CreatorPricingPlan = {
  tier: 'creator' | 'creator_pro'
  name: string
  prices: {
    monthly: StripePlanPrice | null
  }
}

export type CreatorPricingResponse = {
  stripe_configured: boolean
  plans: CreatorPricingPlan[]
}

export async function getCreatorPricing() {
  const { data } = await publicApi.get<CreatorPricingResponse>('/api/creator/pricing/')
  return data
}

